
const SolutionBookData = () => {
 

    const books = [
         //maths
        { image:null,
           alt: '12th Maths',
           name: '12TH MATHS - Chapter : 1 to 4', 
           path: '18r-tGBmxutnTnCOzfHj6vxSaQ6R_GyCN' },
        { image:null,
           alt: '12th Maths',
           name: '12TH MATHS - Chapter : 5', 
           path: '1-OCrZX84YUagv4Z5wOZsPnzrSeZ4JAFj' },
        { image:null,
           alt: '12th Maths',
           name: '12TH MATHS - Chapter : 6', 
           path: '16NQ8NUVOvNQHiQKAx9GfcuFD-IBISQ2-' },
        { image:null,
           alt: '12th Maths',
           name: '12TH MATHS - Chapter : 7', 
           path: '1X1QUDwxXosFNp7Hv3usAG5SipwfFXNlQ' },
        { image:null,
           alt: '12th Maths',
           name: '12TH MATHS - Chapter : 8', 
           path: '1oa4Ly0AOXfA9l5FZXCLmS71QCK19N0om' },
        { image:null,
           alt: '12th Maths',
           name: '12TH MATHS - Chapter : 9', 
           path: '1MJe01pasJ97mzN-3GYqN4nC1oVcrXjCk' },
        { image:null,
           alt: '12th Maths',
           name: '12TH MATHS - Chapter : 10', 
           path: '1FFNaO5deh-SPbH7VATmHiuhBh3x7qwV9' },
        { image:null,
           alt: '12th Maths',
           name: '12TH MATHS - Chapter : 11', 
           path: '1RLklestxxybX8gAmV4F6wRUgZSgUa2vc' },
        { image:null,
           alt: '12th Maths',
           name: '12TH MATHS - Chapter : 12', 
           path: '1zrouMOHofDhlcRTy7UB60u-djI-5RvZe' },
       //
        { image:null,
           alt: '12th Physics',
           name: '12TH Physics-Vol-1,2', 
           path: '1raQK0JGQlMlFneso5lvNzDy8P2DCCqcx' },

        { image:null,
           alt: '12th Chemistry',
           name: '12TH Chemistry-Vol-1,2', 
           path: '1sEpFD5GEhTgpbr1GKQbPN1s7N8ohhyoL' },

        { image:null,
           alt: '12th Bio-Zoology',
           name: '12TH Bio-Zoology', 
           path: '1DkXug2fWGCM6uTKcpWol9Ka0ZOJHyZDc' },

        { image:null,
           alt: '12th Bio-Botany',
           name: '12TH Bio-Botany', 
           path: '1mF6KOtApfSxtt_mApR_P0-s2dwnH393b' },

           //10 th 
        
        { image:null,
           alt: '10th Tamil',
           name: '10th Tamil', 
           path: '1M0fDxilj360GUz68cXy1YVQnLiQnxVop' },

        { image:null,
           alt: '10th English',
           name: '10th English', 
           path: '1o-cJoJUJ7KnSIRZglFu58lpank-T_d9p' },

        { image:null,
           alt: '10th Maths',
           name: '10th maths', 
           path: '1cmkVtOPZqVm0yUnJyhO2uPSt33SKn4i7' },

        { image:null,
           alt: '10th Science',
           name: '10th Science', 
           path: '1UmPR-HdPtQJNMFZtOBGMbO2Eg4FHSyRm' },

        { image:null,
           alt: '10th SocialScience',
           name: '10th SocialScience', 
           path: '1h36zveX2dh1B0NP68UTvJN034Fc7bawy' },

    

       ];

return books;
}

export default SolutionBookData